// extracted by mini-css-extract-plugin
export default {"root":"src-feature-ui-__outlined_root","input":"src-feature-ui-__outlined_input"};